import React from 'react';
import { FiX } from 'react-icons/fi';
import { getBaseButtonStyles, getHoverHandlers } from './buttonStyles';

interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  className?: string;
  style?: React.CSSProperties;
}

const CloseButton: React.FC<CloseButtonProps> = ({ 
  onClick, 
  ariaLabel = "Close", 
  className = "",
  style = {}
}) => {
  const baseStyles = {
    ...getBaseButtonStyles(true), // true = circular
    ...style
  };

  const hoverHandlers = getHoverHandlers();

  return (
    <button
      onClick={onClick}
      style={baseStyles}
      className={className}
      aria-label={ariaLabel}
      {...hoverHandlers}
    >
      <FiX size={20} />
    </button>
  );
};

export default CloseButton;
